<script type="text/javascript">
	import BaseModal from "./modal.svelte";
	import Icon from "../icon.svelte";
	import Loader from "../loader.svelte";
	let opened = true;

	export let login = true;
	export let register = false;
	
	let close;

	let loading = false;

	let apiResponse = {};

	let loginCreds = {login:null, password:null};
	let registerCreds = {login:null, password:null, email:null};
	$: if(!opened && $$props.onClose) $$props.onClose();


	function apiLogin(){
		loading = true;
		window.api.logIn(loginCreds.login, loginCreds.password, result=>{
			loading = false;
			apiResponse = result; console.log(apiResponse);
			if (apiResponse.status === "success") {window.api.refreshUser(); close();}
		})
	}

	function apiRegister(){
		loading = true;
		window.api.register(registerCreds.login, registerCreds.password, registerCreds.email, result=>{
			loading = false;
			apiResponse = result;
			
			if (apiResponse.status === "success") {window.api.refreshUser(); close();}
		})
	}
</script>
{#if opened}
	<BaseModal bind:opened bind:close>
	<span slot="heading">
		{#if login}
		<Icon login /> Войти в аккаунт {/if}
		{#if register} <Icon registr /> Регистрация {/if}
	</span>


		{#if apiResponse && apiResponse.status == "error"}
			<div class="message">
				<span>{apiResponse.message}</span>
			</div>
		{/if}

		{#if login}
			<form action="#" on:submit|preventDefault={apiLogin}>
				<div class="form-group">
					<label for="login">Логин/почта</label>
					<input type="text" id="login" bind:value={loginCreds.login} class="app_input-default">
				</div>
				<div class="form-group">
					<label for="password">Пароль</label>
					<input type="password" id="password" bind:value={loginCreds.password} class="app_input-default">
				</div>
				<div class="d-flex login-block">
					<button type="submit" class="app_button-primary col-10">
						{#if login && loading}
							<Loader/>
						{:else} Вход
						{/if}</button>
					<a href={`https://oauth.vk.com/authorize?client_id=7753508&display=page&redirect_uri=${encodeURIComponent(location.origin+"/romanAbdulaev")}&response_type=code&v=5.103`} class="app_button-secondary blu col-2"><Icon vk/></a>
				</div>
				<button class="app_button-secondary col-12"
						on:click={e=>{register = true; login = false; apiResponse = null;}}>Регистрация</button>

			</form>
		{/if}

		{#if register}

			<form action="#" on:submit|preventDefault={apiRegister}>
				<div class="form-group">
					<label for="login">Логин</label>
					<input type="text" id="login" bind:value={registerCreds.login} class="app_input-default">
				</div>
				<div class="form-group">
					<label for="password">Пароль</label>
					<input type="password" id="password" bind:value={registerCreds.password} class="app_input-default">
				</div>
				<div class="form-group">
					<label for="email">Почта</label>
					<input type="email" id="email" bind:value={registerCreds.email} class="app_input-default">
				</div>
				<div class="d-flex login-block">
					<button class="app_button-primary col-10">
						{#if loading && register}
							<Loader/>
						{:else} Регистрация
						{/if}</button>
					<a href={`https://oauth.vk.com/authorize?client_id=7753508&display=page&redirect_uri=${encodeURIComponent(location.origin+"/romanAbdulaev")}&response_type=code&v=5.103`} class="app_button-secondary blu col-2"><Icon vk/></a>
				</div>
				<button class="app_button-secondary col-12"
						on:click={e=>{register = false; login = true; apiResponse = null;}}>Вход</button>

			</form>


		{/if}
	</BaseModal>
{/if}

<style type="text/css">
	
	:global(body.svelte_widget .blu){
		max-width: none !important;
	}
	.login-block > .app_button-primary{
		border-bottom-right-radius: 0;
		border-top-right-radius: 0; 
	}

	.login-block > .blu{
		border-top-left-radius: 0;
		border-bottom-left-radius: 0; max-width: 25px;
	}


	.login-block{
		margin-bottom: 10px;
	}

	.blu{
		background:  #0077FF;
		padding: 15px;
	}
</style>